// astro vue will render empty page if import vue from 'vue'
// @ts-ignore
import { createApp } from 'vue/dist/vue.esm-bundler.js'
import hybridPage from '@/lib/hybridPage'
import { GaGeneralPageName } from '@/assets/ts/customEvent'
import { setCurrentGaPageName } from '@/lib/utils'
import MercariBrandListing from '@/pages/mercari-brand-listing/components/_MercariBrandListing.vue'

hybridPage()

createApp({
	name: 'Mercari Brand Listing Page',
	components: {
		MercariBrandListing,
	},
	setup() {
		setCurrentGaPageName(GaGeneralPageName.MercariBrandListing)

		const { mercariBrandListingPageContent } = window.pageContent

		return {
			mercariBrandListingPageContent,
		}
	},
}).mount('#bsMain')
